import { render, staticRenderFns } from "./TerritoryAdministrativeArea.vue?vue&type=template&id=82c4d38a&"
import script from "./TerritoryAdministrativeArea.vue?vue&type=script&lang=ts&"
export * from "./TerritoryAdministrativeArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports